import React from 'react';
import { ShoppingCart as ShoppingCartIcon, X, CheckCircle } from 'lucide-react';
import CartItem from './CartItem';
import { formatCurrency, WHATSAPP_NUMBER } from '../utils/helpers';

const ShoppingCart = ({ cartItems, onUpdateQuantity, onRemoveItem, onClose, customerName }) => {
  const subtotal = cartItems.reduce((sum, item) => sum + item.pricePerPound * item.quantity, 0);

  const generateWhatsAppMessage = () => {
    if (cartItems.length === 0) return '';

    let message = `¡Hola! Soy ${customerName || 'un cliente'} y me gustaría hacer un pedido de 'Del Mar a Tu Mesa':\n\n`;
    cartItems.forEach(item => {
      message += `- ${item.name} (${item.quantity.toFixed(1)} lb) - ${formatCurrency(item.pricePerPound * item.quantity)}\n`;
    });
    message += `\nSubtotal: ${formatCurrency(subtotal)}\n\n`;
    message += "¡Espero su confirmación!";
    
    return encodeURIComponent(message);
  };

  const handleCheckout = () => {
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${generateWhatsAppMessage()}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end">
      <div className="bg-white w-full max-w-md h-full shadow-2xl flex flex-col">
        <div className="p-4 sm:p-6 border-b border-gray-200 flex items-center justify-between">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800 flex items-center gap-2 sm:gap-3">
            <ShoppingCartIcon className="w-6 h-6 sm:w-7 sm:h-7 text-blue-600" />
            Tu Carrito
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-grow p-4 sm:p-6 overflow-y-auto space-y-4">
          {cartItems.length === 0 ? (
            <div className="text-center py-12">
              <ShoppingCartIcon className="w-16 h-16 sm:w-20 sm:h-20 text-gray-300 mx-auto mb-4 sm:mb-6" />
              <p className="text-gray-500 text-base sm:text-lg font-medium">Tu carrito está vacío. ¡Añade algo delicioso!</p>
            </div>
          ) : (
            cartItems.map(item => (
              <CartItem
                key={item.cartItemId}
                item={item}
                onUpdateQuantity={onUpdateQuantity}
                onRemoveItem={onRemoveItem}
              />
            ))
          )}
        </div>

        <div className="p-4 sm:p-6 border-t border-gray-200 bg-white">
          <div className="flex justify-between items-center mb-4">
            <span className="text-lg sm:text-xl font-bold text-gray-800">Subtotal:</span>
            <span className="text-xl sm:text-2xl font-extrabold text-blue-700">
              {formatCurrency(subtotal)}
            </span>
          </div>
          <button
            onClick={handleCheckout}
            disabled={cartItems.length === 0}
            className={`w-full py-3 sm:py-4 rounded-xl font-bold text-base sm:text-lg flex items-center justify-center gap-2 sm:gap-3 ${
              cartItems.length > 0
                ? 'bg-gradient-to-r from-green-500 to-green-700 text-white shadow-lg hover:from-green-600 hover:to-green-800'
                : 'bg-gray-200 text-gray-500 cursor-not-allowed'
            }`}
          >
            <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6" />
            Comprar Todo por WhatsApp
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShoppingCart;